import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ activeTab, onTabChange }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleNavClick = (id) => {
    // Desktop: change tab
    if (window.innerWidth >= 1024 && onTabChange) {
      onTabChange(id);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    } else {
      // Mobile: scroll to section
      scrollToSection(id);
    }
  };

  const navItems = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'productos', label: 'Productos' },
    { id: 'capacidad', label: 'Capacidad' },
    { id: 'calidad', label: 'Calidad' },
    { id: 'galeria', label: 'Galería' },
    { id: 'contacto', label: 'Contacto' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/058gyoft_WhatsApp%20Image%202026-02-20%20at%207.23.33%20PM.jpeg"
              alt="GONSO - Produciendo para Honduras"
              className="h-16 w-auto cursor-pointer"
              onClick={() => handleNavClick('inicio')}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10 xl:space-x-12 pr-8 xl:pr-12">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`font-medium transition-all duration-200 px-2 py-1 rounded ${
                  activeTab === item.id
                    ? 'text-[#019645] bg-[#019645]/10 font-semibold'
                    : 'text-gray-700 hover:text-[#019645]'
                }`}
              >
                {item.label}
              </button>
            ))}
            <Button
              onClick={() => handleNavClick('contacto')}
              className="bg-[#019645] hover:bg-[#077c38] text-white transition-all duration-300 ml-4"
            >
              Cotizar Ahora
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700 hover:text-[#019645] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden pb-4 animate-in slide-in-from-top-5 duration-300">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#019645] transition-colors"
              >
                {item.label}
              </button>
            ))}
            <div className="px-4 pt-2">
              <Button
                onClick={() => handleNavClick('contacto')}
                className="w-full bg-[#019645] hover:bg-[#077c38] text-white"
              >
                Cotizar Ahora
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
